<template>
  <v-snackbar v-model="snackbar" top shaped :color="color" absolute app>
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  data: () => ({
    snackbar: false,
    text: "",
  }),
  props: {
    color: {
      type: String,
      required: false,
      default: "success",
    },
  },
  methods: {
    Abrir(msj) {
      this.text = msj;
      this.snackbar = true;
    },
  },
};
</script>
